module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarX-4@3x.91f1a0bb.png";